module.exports = {"id":"51261","name":"Boaz Myhill","rating":"73","photo":"./data/images/photos/0/51261.png","club":{"name":"West Bromwich","logo":"./data/images/clubs/WestBromwich.png"},"positions":["G"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BoazMyhill0.json
// module id = 610
// module chunks = 0